<template>
  <q-banner :class="'n-callout n-callout-' + type" rounded dense>
    <div class="row items-center no-wrap q-gutter-x-sm">
      <q-icon :name="icon || icons[type]" size="1.5em" />
      <div>{{ text }}<slot /></div>
    </div>
  </q-banner>
</template>

<script setup>
defineProps({
  // стиль: info, success, warning, error
  type: {
    type: String,
    default: 'default'
  },
  // текст сообщения
  text: {
    type: String,
    default: ''
  },
  // иконка диалога
  icon: {
    type: String,
    default: null
  },
  // цвет диалога
  color: {
    type: String,
    default: 'primary'
  }
})

const icons = {
  default: 'lightbulb',
  info: 'info',
  success: 'check_circle',
  warning: 'warning',
  error: 'cancel'
}
</script>

<style lang="scss">
.n-callout {
  background: #9993;
  border: 1px solid #bbba;

  i {
    color: $grey-8;
  }

  &.n-callout-info {
    background-color: #1976d244;
    border-color: #1976d255;

    i {
      color: #1976d2;
    }
  }

  &.n-callout-warning {
    background-color: #ffd2095a;
    border-color: #f6b503aa;

    i {
      color: #fb0;
    }
  }

  &.n-callout-error {
    background-color: #f4433644;
    border-color: #c10015aa;

    i {
      color: #c10015;
    }
  }

  &.n-callout-success {
    background-color: #4caf5055;
    border-color: #81c784aa;

    i {
      color: #4caf50;
    }
  }
}
</style>
